<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Shift
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field 
              name="name" 
              label="Shift Name" 
              type="text" 
              v-model="queryParams.name"
            ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="shiftInfoList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.startHour }}</td>
              <td>{{ props.item.endHour }}</td>
              <!-- <td>{{ props.item.shopName }}</td> -->
              <td>
                <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { shiftInfoService } from "../../services/shift-info-service";

export default {
  name: "ShiftInfoList",

  components: {},
  data: () => ({
    showListLoading: false,
    pageTitle: "Shift Info",
    breadcrumbs: [
      {
        text: "User Management",
        disabled: true
      },
      {
        text: "Shift Info",
        disabled: true
      }
    ],
    headers: [
      { text: "Shift Name", align: "left", value: "name" },
      { text: "Start Hour", align: "left", value: "startHour" },
      { text: "End Hour", align: "left", value: "endHour" },
      // { text: "Shop Name", align: "left", value: "shopName" },
      { text: "Status", value: "status", sortable: false },
      { text: "Action", value: "name", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0
    },
    shiftInfoList: [],
    totalRows: 0,
    statusList: [
      { label: "--- Select Status ---", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    queryParams: {
      name: "",
      status: "",
      shopId: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getShiftInfoList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    let user = JSON.parse(localStorage.getItem("user"));
    this.queryParams.shopId = user.shopId;
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "shift-infos", query: this.queryParams });
      this.getShiftInfoList();
    },
    getShiftInfoList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      shiftInfoService
        .getShiftInfoList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.shiftInfoList = res.data.shiftInfoList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/shift-info/new");
    },
    onEdit(shiftInfo) {
      // go to details page
      this.$router.push("/shift-info/" + shiftInfo.id);
    }
  }
};
</script>